'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCredentials = getCredentials;
var _ = require('./');
var credentials = {
  'import.io': {
    apiKey: 'AIzaSyDyaZK0cequmKrAlQfEb9T6BJwIymPLMKQ',
    authDomain: 'importio-prod.firebaseapp.com',
    databaseURL: 'https://importio-prod.firebaseio.com',
    storageBucket: 'importio-prod.appspot.com'
  },
  'staging-owl.com': {
    apiKey: 'AIzaSyAtIIR4bfFcr7MOZy6OKSvjnNErzmF_GEI',
    authDomain: 'importio-staging.firebaseapp.com',
    databaseURL: 'https://importio-staging.firebaseio.com',
    storageBucket: 'importio-staging.appspot.com'
  },
  'demo-owl.com': {
    apiKey: 'AIzaSyDhdNVPHOnocqULG_C2U5Js7T-l75qLh1I',
    authDomain: 'importio-demo.firebaseapp.com',
    databaseURL: 'https://importio-demo.firebaseio.com',
    storageBucket: 'importio-demo.appspot.com'
  },
  dev: {
    apiKey: 'AIzaSyBPPVyLdnBlJ632gtpC3Pk1udoc_zE6__o',
    authDomain: 'importio-dev.firebaseapp.com',
    databaseURL: 'https://importio-dev.firebaseio.com',
    storageBucket: 'importio-dev.appspot.com'
  }
};
function getCredentials() {
  if (process.env.FIREBASE_CREDENTIALS) {
    return credentials[process.env.FIREBASE_CREDENTIALS];
  }
  return credentials[_.endpoints.rootDomain];
}